import type { AxiosError, AxiosRequestConfig } from 'axios';
import { ElMessage } from 'element-plus';

export const HANDLED_HTTP_ERROR = 'isHandledHttpError';

export function markHandledError<T extends Error>(error: T): T {
  (error as T & { isHandledHttpError?: boolean })[HANDLED_HTTP_ERROR] = true;
  return error;
}

export function isHandledHttpError(error: unknown): boolean {
  return !!(
    error && (error as { isHandledHttpError?: boolean })[HANDLED_HTTP_ERROR]
  );
}

export function shouldToggleMask(config?: AxiosRequestConfig): boolean {
  if (!config) {
    return true;
  }
  if (config.method === 'get') {
    return !config.params || !config.params.isMask;
  }
  if (!config.data) {
    return true;
  }
  if (typeof config.data === 'string') {
    return !config.data.includes('isMask');
  }
  return !(config.data as { isMask?: boolean }).isMask;
}

export function getAxiosErrorMessage(error: AxiosError): string {
  const status = error.response?.status;
  const raw = error.message || '';
  if (
    !error.response ||
    error.code === 'ECONNABORTED' ||
    raw === 'Network Error' ||
    raw.includes('timeout') ||
    status === 502 ||
    status === 503 ||
    status === 504
  ) {
    return 'Network Error';
  }
  return raw || 'Network Error';
}

export function rejectBizError(message?: string): Promise<never> {
  const text = message || 'Error';
  ElMessage.error({
    message: text,
    duration: 5 * 1000,
  });
  return Promise.reject(markHandledError(new Error(text)));
}

export function notifyAxiosError(
  error: AxiosError,
  hideMask?: () => void
): Promise<never> {
  if (hideMask && shouldToggleMask(error.config)) {
    hideMask();
  }
  ElMessage.error({
    message: getAxiosErrorMessage(error),
    duration: 5 * 1000,
  });
  return Promise.reject(markHandledError(error));
}
